import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoMuteIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M18.0003 16.7503C17.8403 16.7503 17.6903 16.7003 17.5503 16.6003C17.2203 16.3503 17.1503 15.8803 17.4003 15.5503C18.9703 13.4603 18.9703 10.5403 17.4003 8.45027C17.1503 8.12027 17.2203 7.65027 17.5503 7.40027C17.8803 7.15027 18.3503 7.22027 18.6003 7.55027C20.5603 10.1703 20.5603 13.8303 18.6003 16.4503C18.4503 16.6503 18.2303 16.7503 18.0003 16.7503Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.8284 19.2503C19.6684 19.2503 19.5184 19.2003 19.3784 19.1003C19.0484 18.8503 18.9784 18.3803 19.2284 18.0503C21.8984 14.4903 21.8984 9.51027 19.2284 5.95027C18.9784 5.62027 19.0484 5.15027 19.3784 4.90027C19.7084 4.65027 20.1784 4.72027 20.4284 5.05027C23.4984 9.14027 23.4984 14.8603 20.4284 18.9503C20.2884 19.1503 20.0584 19.2503 19.8284 19.2503Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.02 3.77777C12.9 3.15777 11.47 3.31777 10.01 4.22777L7.09 6.05777C6.89 6.17777 6.66 6.24777 6.43 6.24777H5.5L5 6.24777C2.58 6.24777 1.25 7.57777 1.25 9.99777L1.25 13.9978C1.25 16.4178 2.58 17.7478 5 17.7478H5.5H6.43C6.66 17.7478 6.89 17.8178 7.09 17.9378L10.01 19.7678C10.89 20.3178 11.75 20.5878 12.55 20.5878C13.07 20.5878 13.57 20.4678 14.02 20.2178C15.13 19.5978 15.75 18.3078 15.75 16.5878L15.75 7.40777C15.75 5.68777 15.13 4.39777 14.02 3.77777Z",
			fill: "white"
		})
	]
});
export default SvgNoMuteIcon;
